module.exports = __webpack_public_path__ + "img/brand-pic2-02.8da1707e.png";